export default __webpack_public_path__ + "static/media/06TrapezeSong60s.452969c2.mp3";